import {AnimatePresence, View} from 'moti';
import {Pressable, Row, ScrollView, useTheme} from 'native-base';
import Collapsible from 'react-native-collapsible';
import {IHStackProps} from 'native-base/lib/typescript/components/primitives/Stack/HStack';
import IcCircleCross from '@ui/svg/IcCircleCross';
import {Layout} from 'react-native-reanimated';
import ParticipantAvatar from '@ui/components/participant/ParticipantAvatar';
import {Platform} from 'react-native';
import React from 'react';
import {UserUiData} from '@shared/models/user';

interface Props extends IHStackProps {
    players: UserUiData[];
    removePlayer: (player: UserUiData) => void;
}

const SelectedPlayersRow = (props: Props) => {
    const {players, removePlayer} = props;
    const theme = useTheme();
    const crossColor = theme.colors.secondary[300];

    return (
        <Collapsible collapsed={players.length === 0}>
            <ScrollView horizontal showsHorizontalScrollIndicator={Platform.OS === 'web'}>
                <Row py='5' h={120} w='full' {...props} >
                    <AnimatePresence>
                        {players.map(player => (
                            <View
                                from={{
                                    scale: 0,
                                    opacity: 0,
                                }}
                                animate={{
                                    scale: 1,
                                    opacity: 1,
                                }}
                                exit={{
                                    scale: 0,
                                    opacity: 0,
                                }}
                                layout={Layout.springify()}
                                key={player.id}
                            >
                                <ParticipantAvatar
                                    participant={player}
                                    space='1'
                                    flex={1}
                                    py={1}
                                    _avatar={{size: 'md'}}
                                    w='16'
                                />

                                <Pressable variant='outline' position='absolute' top='0' right='0' onPress={() => removePlayer(player)}>
                                    <IcCircleCross width={24} height={24} fill={crossColor} border={crossColor} />
                                </Pressable>
                            </View>
                        ))}
                    </AnimatePresence>
                </Row>
            </ScrollView>
        </Collapsible>
    );
};

export default SelectedPlayersRow;
